import { ReactNode } from 'react'
import WindowChrome from './WindowChrome'

interface WindowContainerProps {
  children: ReactNode
}

export default function WindowContainer({ children }: WindowContainerProps) {
  return (
    <div className="min-h-screen bg-beige">
      <div className="w-[var(--window-width)] mx-auto my-12 mb-20 bg-surface rounded-window shadow-soft overflow-hidden">
        <WindowChrome />
        <div className="px-16 pb-16 bg-gradient-to-b from-[rgba(248,248,252,0.68)] to-surface">
          {children}
        </div>
      </div>
    </div>
  )
}
